export function brands() {
  $('.brands-button-collapse').click(function (e) {
    e.preventDefault();
    $('.logo-wrap').toggleClass('logo-collapse');
    $('.logo-content-not-visible').slideToggle();
  });
}



// WEBPACK FOOTER //
// ./scripts/components/brands.js